import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'

export interface IntentVariant {
  mentions: number
  name: string
}

export interface IntentData {
  canonicalId: string
  id: string
  intent: string
  mostlyRatedAs: 'positive' | 'neutral' | 'negative' | string
  negativeMentions: number
  negativePercentage: number
  neutralMentions: number
  neutralPercentage: number
  positiveMentions: number
  positivePercentage: number
  totalMentions: number
  variants?: IntentVariant[]
}

export interface TopIntentsResponse {
  intents: IntentData[]
}

interface UseGetTopIntentsParams {
  fromDate?: string
  limit?: number
  pageId: string
  toDate?: string
}

export const useGetTopIntentsQuery = (params: UseGetTopIntentsParams) => {
  return useQuery<TopIntentsResponse | null>({
    enabled: !!params.pageId,
    queryFn: async () => {
      const { data } = await analyticsApi().get<TopIntentsResponse>(
        '/v1_private/inbox-analysis/top-intents',
        {
          params: {
            fromDate: params.fromDate,
            limit: params.limit,
            pageId: params.pageId,
            toDate: params.toDate,
          },
        }
      )
      return data
    },
    queryKey: [
      QueryKey.GET_TOP_INTENTS,
      params.pageId,
      params.fromDate,
      params.toDate,
      params.limit,
    ],
  })
}
